<template>
  <div>
    <h1 class="h3">Tell us about your tires.</h1>
    <p class="label m-10"><sup>*</sup> required</p>
    <b-row>
      <b-col md="3">
        <ValidationProvider rules="required" name="select-tire-width" v-slot="{ errors }" slim>
          <b-form-group id="select-group-tire-width" label="Tire Width*" label-for="select-tire-width">
            <b-form-select
              id="select-tire-width"
              aria-describedby="select-tire-width-error"
              v-model="selected_tire_width"
              :options="options.tire_width"
              :state="errors[0] ? false : null"
              class="btn-double-outline btn-double-outline--normal"
              v-remove-aria-required
            />
            <b-form-invalid-feedback id="select-tire-width-error" v-if="errors.length">
              Error: Tire Width is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="3">
        <ValidationProvider rules="required" name="select-aspect-ratio" v-slot="{ errors }" slim>
          <b-form-group
            id="select-group-aspect-ratio"
            label="Aspect Ratio*"
            label-for="select-aspect-ratio"
            >
            <b-form-select
              id="select-aspect-ratio"
              aria-describedby="select-aspect-ratio-error"
              v-model="selected_aspect_ratio"
              :options="options.aspect_ratio"
              :state="errors[0] ? false : null"
              class="btn-double-outline btn-double-outline--normal"
              v-remove-aria-required
            />
            <b-form-invalid-feedback id="select-aspect-ratio-error" v-if="errors.length">
              Error: Aspect Ratio is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="3">
        <ValidationProvider rules="required" name="select-diameter" v-slot="{ errors }" slim>
          <b-form-group id="select-group-diameter" label="Diameter*" label-for="select-diameter">
            <b-form-select
              id="select-diameter"
              aria-describedby="select-diameter-error"
              v-model="selected_diameter"
              :options="options.diameter"
              :state="errors[0] ? false : null"
              class="btn-double-outline btn-double-outline--normal"
              v-remove-aria-required
            />
            <b-form-invalid-feedback id="select-diameter-error" v-if="errors.length">
              Error: Diameter is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="3">
        <ValidationProvider rules="required" name="select-tire-name" v-slot="{ errors }" slim>
          <b-form-group id="select-group-tire-name" label="Tire Name*" label-for="select-tire-name">
            <b-form-select
              id="select-tire-name"
              aria-describedby="select-tire-name-error"
              v-model="selected_tire_name"
              :options="options.tire_name"
              :state="errors[0] ? false : null"
              class="btn-double-outline btn-double-outline--normal"
              v-remove-aria-required
            />
            <b-form-invalid-feedback id="select-tire-name-error" v-if="errors.length">
              Error: Tire Name is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'TireInfo',
  data() {
    return {
      options: {
        tire_width: [{ value: null, text: 'Width', disabled: true }],
        aspect_ratio: [{ value: null, text: 'Aspect Ratio', disabled: true }],
        diameter: [{ value: null, text: 'Diameter', disabled: true }],
        tire_name: [{ value: null, text: 'Tire Name', disabled: true }],
      },
    };
  },
  created() {
    this.fetchTireWidths();
  },
  watch: {
    selected_tire_width(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.fetchAspectRatios();
        this.validateStep();
      }
    },
    selected_aspect_ratio(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.fetchDiameters();
        this.validateStep();
      }
    },
    selected_diameter(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.fetchTireNames();
        this.validateStep();
      }
    },
    selected_tire_name(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.validateStep();
      }
    },
  },
  computed: {
    selected_tire_width: {
      get() {
        return this.$store.state.TireWidth;
      },
      set(value) {
        this.$store.dispatch('tireWidth', value);
      },
    },
    selected_aspect_ratio: {
      get() {
        return this.$store.state.TireAspect;
      },
      set(value) {
        this.$store.dispatch('tireAspect', value);
      },
    },
    selected_diameter: {
      get() {
        return this.$store.state.TireDiameter;
      },
      set(value) {
        this.$store.dispatch('tireDiameter', value);
      },
    },
    selected_tire_name: {
      get() {
        return this.$store.state.TireName;
      },
      set(value) {
        this.$store.dispatch('tireName', value);
      },
    },
  },
  methods: {
    async fetchTireWidths() {
      try {
        const path = 'vehicle/widths';
        const results = await this.axios.get(path);

        this.options.tire_width = [...this.options.tire_width, ...results.data];
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    async fetchAspectRatios() {
      this.resetValues('aspect');

      try {
        const path = 'vehicle/aspectratios';

        const results = await this.axios.get(path);
        this.options.aspect_ratio = [...this.options.aspect_ratio, ...results.data];
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    async fetchDiameters() {
      this.resetValues('diameter');

      try {
        const path = 'vehicle/diameters';
        const params = {
          width: this.selected_tire_width,
          aspect: this.selected_aspect_ratio,
        };
        const results = await this.axios.get(path, { params });
        this.options.diameter = [...this.options.diameter, ...results.data];
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    async fetchTireNames() {
      this.resetValues('tire_name');

      try {
        const path = 'vehicle/tirenames';
        const results = await this.axios.get(path);
        this.options.tire_name = [...this.options.tire_name, ...results.data];
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    resetValues(step) {
      switch (step) {
        case 'aspect':
          this.options.aspect_ratio = [{ value: null, text: 'Aspect Ratio', disabled: true }];
          this.options.diameter = [{ value: null, text: 'Diameter', disabled: true }];
          this.options.tire_name = [{ value: null, text: 'Tire Name', disabled: true }];
          this.$store.dispatch('tireAspect', null);
          this.$store.dispatch('tireDiameter', null);
          this.$store.dispatch('tireName', null);
          break;
        case 'diameter':
          this.options.diameter = [{ value: null, text: 'Diameter', disabled: true }];
          this.options.tire_name = [{ value: null, text: 'Tire Name', disabled: true }];
          this.$store.dispatch('tireDiameter', null);
          this.$store.dispatch('tireName', null);
          break;
        case 'tire_name':
          this.options.tire_name = [{ value: null, text: 'Tire Name', disabled: true }];
          this.$store.dispatch('tireName', null);
          break;
        default:
          break;
      }
    },
    validateStep() {
      this.$nextTick(() => this.$emit('onValidate', null));
    },
  },
};
</script>

<style scoped>
h1 {
  margin-bottom: 16px;
}
</style>
